<template>
  <div class="w-full">
    <div class="documents--container lg:overflow-y-auto">
      <div class="">
        <p class="documents--title pb-3">
          {{ $t('message.documentComponent.SignedDocuments.myDocuments') }}
        </p>
        <zt-tab alignment="fixed" theme="secondary" v-if="showChip">
          <zt-tab-item>
            <template #title>
              <div class="flex justify-end">
                <p class="pr-2">
                  {{ $t('message.documentComponent.pending') }}
                </p>
                <div v-if="getUnsignedTotalDocsLength">
                  <UnsignedChip
                    :total="getUnsignedTotalDocsLength"
                    :key="unsignedKey"
                    class="chip--unsigned items-center justify-center"
                  />
                </div>
              </div>
            </template>
            <UnsignedEmptyState
              v-if="
                hasNotFilterApplied &&
                  getUnsignedTotalDocsLength === 0 &&
                  !requestActive
              "
              :showDocument="showDocumentDetail"
              :windowWidth="windowWidth"
            />
            <div v-else>
              <div>
                <FilterBar
                  :appliedFilters="$store.state.documents.unsignedFilters"
                  :setFilters="applyUnsignedFilters"
                />
              </div>
              <UnSignedDocs
                :unsignedDocs="setUnsignedDocs"
                :docSelected="itemSelected"
                :showAlert="alertForDocsBlocked"
                :showDocument="showDocumentDetail"
                :windowWidth="windowWidth"
                :key="getUnsignedDocsInboxID"
              />
            </div>
          </zt-tab-item>
          <zt-tab-item :label="$t('message.documentComponent.signed')">
            <div>
              <FilterBar
                :appliedFilters="$store.state.documents.signedFilters"
                :setFilters="applySignedFilters"
                :downloadDocs="true"
              />
            </div>
            <SignedDocs
              :signedDocs="setSignedDocs"
              :docSelected="itemSelected"
              :showDocument="showDocumentDetail"
              :windowWidth="windowWidth"
            />
          </zt-tab-item>
        </zt-tab>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import { isEmpty, filter, includes } from 'lodash'
import FilterBar from './FilterBar'
import moment from 'moment'
import Users from '@/apiClient/Users'
import UnSignedDocs from './UnsignedDocs'
import SignedDocs from './SignedDocs'
import UnsignedEmptyState from './UnsignedEmptyState'
import UnsignedChip from './UnsignedChip'

export default {
  name: 'DocumentsList',
  props: ['setDocumentId', 'windowWidth'],
  components: {
    FilterBar,
    UnSignedDocs,
    SignedDocs,
    UnsignedEmptyState,
    UnsignedChip
  },
  data() {
    return {
      itemSelected: '',
      unsignedFilters: {},
      signedFilters: {},
      profile: '',
      idApp: '',
      unsignedKey: 0,
      showChip: true,
      requestActive: false
    }
  },
  created() {
    this.profile = new Users()
    this.idApp = this.user.aplicacion.id
  },
  watch: {
    getUnsignedTotalDocsLength() {
      this.showChip = false
      this.$nextTick(() => {
        this.showChip = true
      })
    }
  },
  computed: {
    ...mapGetters('documents', [
      'getSignedDocs',
      'getUnsignedDocs',
      'getUnsignedDocsInbox',
      'getSignedDocsInbox',
      'getUnsignedTotalDocsLength'
    ]),
    ...mapState(['user']),
    setUnsignedDocs() {
      if (this.isInboxDocumentActivated) {
        return this.getUnsignedDocsInbox
      }
      const {
        foldersSelected,
        dateFilters
      } = this.unsignedFilters

      let results = this.getUnsignedDocs

      if (!isEmpty(foldersSelected)) {
        results = filter(results, doc =>
          includes(foldersSelected, doc.carpeta_nombre)
        )
      }
      if (dateFilters && dateFilters.start && dateFilters.end) {
        const decodeStartDate = moment(dateFilters.start, 'MM/YYYY')
        const decodeEndDate = moment(dateFilters.end, 'MM/YYYY')
        results = filter(results, doc => {
          const period = moment(doc.periodo, 'MM/YYYY')
          return period >= decodeStartDate && period <= decodeEndDate
        })
      }
      return results
    },
    setSignedDocs() {
      if (this.isInboxDocumentActivated) {
        return this.getSignedDocsInbox
      }

      const {
        foldersSelected,
        dateFilters
      } = this.signedFilters

      let results = this.getSignedDocs

      if (!isEmpty(foldersSelected)) {
        results = filter(results, doc =>
          includes(foldersSelected, doc.carpeta_nombre)
        )
      }

      if (dateFilters && dateFilters.start && dateFilters.end) {
        const decodeStartDate = moment(dateFilters.start, 'MM/YYYY')
        const decodeEndDate = moment(dateFilters.end, 'MM/YYYY')
        return filter(results, doc => {
          const period = moment(doc.periodo, 'MM/YYYY')
          return period >= decodeStartDate && period <= decodeEndDate
        })
      }

      return results
    },
    isInboxDocumentActivated() {
      const actions = this.$store.state.actions
      return actions.some(action => action.id === '304')
    },
    hasNotFilterApplied() {
      return isEmpty(this.$store.state.documents.unsignedFilters)
    },
    getUnsignedDocsInboxID() {
      if (!this.isInboxDocumentActivated) return 0
      if (this.getUnsignedDocsInbox.length) {
        return this.getUnsignedDocsInbox[0].id + Date.now()
      }
      return 0
    }
  },
  methods: {
    ...mapActions('documents', [
      'setDocumentSelected',
      'setUnsignedFilters',
      'setSignedFilters',
      'clearSigned',
      'clearUnSigned',
      'setDocumentsSigned',
      'setDocumentsUnSigned'
    ]),
    alertForDocsBlocked() {
      this.$swal({
        type: 'warning',
        title: this.$t(
          'message.documentComponent.warnings.titleDocumentBloqued'
        ),
        text: this.$t(
          'message.documentComponent.warnings.subtitleDocumentBloqued'
        ),
        showConfirmButton: true,
        confirmButtonText: this.$t(
          'message.DocumentsComponents.alerts.blockedDocument'
        )
      })
    },
    async showDocumentDetail(item) {
      try {
        if (!item.locked) {
          if (includes(item.tipo_formato, 'pdf')) {
            await this.profile.getDocumentInfo(this.idApp, item.id)
          }
          this.itemSelected = item.id
          this.setDocumentId(item.id)
          this.setDocumentSelected(item)
          if (this.windowWidth < 1023) {
            this.$router.push('/documents/detail')
          }
        }
      } catch (error) {
        this.$swal({
          type: 'error',
          title: this.$t(
            'message.DocumentsComponents.alerts.dontPermissionDoc'
          ),
          showConfirmButton: true,
          confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
        })
      }
    },
    async applyUnsignedFilters(filters) {
      if (this.isInboxDocumentActivated) {
        this.requestActive = true
        await this.setUnsignedFilters({ filters })
        await this.setDocumentsUnSigned({ append: false })
        this.requestActive = false
        return
      }
      this.unsignedFilters = { ...filters }
    },
    async applySignedFilters(filters) {
      if (this.isInboxDocumentActivated) {
        this.setSignedFilters({ filters })
        await this.setDocumentsSigned({ append: false })
        return
      }
      this.signedFilters = { ...filters }
    }
  },
  beforeDestroy() {
    if (this.isInboxDocumentActivated) {
      this.setUnsignedFilters({
        filters: {}
      })
      this.setSignedFilters({
        filters: {}
      })
    }
  }
}
</script>
<style scoped>
.documents--container {
  max-height: calc(100vh - 40px - 64px);
}

.chip--unsigned {
  width: 24px;
  height: 20px;
  background: #898dff;
  border-radius: 50px;
  display: flex;
}

.documents--title {
  color: #707070;
  font-size: 24px;
  line-height: 28px;
}
</style>
